import Vue from 'vue'
import Router from 'vue-router'
// 详情 info  列表 list  编辑 edit 创建 create
// 路由名字用 - 不需要 驼峰
// 小程序命名 wechat_applet 和 wechatApplet
// 用户中心-用户账号集合+零散小功能操作板块
import UserHomeRouterMap from './modules/user/home'
// 用户中心-账号信息操作
import UserAccountRouterMap from './modules/user/account'
// 用户中心-用户出行人操作
import UserContactRouterMap from './modules/user/contact'
// 用户中心-优惠券操作
import UserCouponRouterMap from './modules/user/coupon'
// 用户中心-发票功能操作
import UserInvoiceRouterMap from './modules/user/invoice'
// 用户中心-会员操作
import UserMemberRouterMap from './modules/user/member'
// 用户中心-用户消息操作
import UserMessageRouterMap from './modules/user/message'
// 用户中心-老带新推荐操作
import UserRecommendRouterMap from './modules/user/recommend'
// 用户中心-用户积分操作
import UserScoreRouterMap from './modules/user/score'
// 用户中心-用户订单操作板块
import UserOrderRouterMap from './modules/order/order'

Vue.use(Router)
// 导出当前使用的路由 合并分系统路由
export const constantRouterMap = [
  { path: '*', component: UserLost => (require(['@/views/lost/404'], UserLost)) }
].concat(UserAccountRouterMap, UserOrderRouterMap, UserContactRouterMap, UserCouponRouterMap, UserHomeRouterMap, UserInvoiceRouterMap, UserMemberRouterMap, UserMessageRouterMap, UserRecommendRouterMap, UserScoreRouterMap)

export default new Router({
  mode: 'history', // 后端支持可开
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js